export default {
  MSG_ERROR_REQUIRED: 'This field is required',
  MSG_HTTP_ERROR_BAD_REQUEST: 'Request failed with status code {0}',
  MSG_HTTP_ERROR_REQUEST_CANCELLED: 'The request was cancelled',
  MSG_ADMIN_SUCCESS_DELETE: 'User {0} has been deleted.',
  MSG_ADMIN_SUCCESS_CREATE: 'User "{0}" has been added successfully.',
  MSG_ADMIN_SUCCESS_MODIFY: 'Changes to user "{0}" has been saved.',
  MSG_CONFIRM_DELETE: 'Are you sure you want to delete "{0}"?',
  MSG_DELETE_SUCCESS: '"{0}" has been deleteted successfully.',
  MSG_CONFIG_ADD_SUCCESS: 'New key "{0}" has been added successfully.',
  MSG_SENSITIVE_COMMUNITY_ADD_SUCCESS: 'Sensitive Community "{0}" has been added successfully.',
  MSG_SENSITIVE_COMMUNITY_EDIT_SUCCESS: 'Changes to sensitive Community "{0}" have been saved.',
  MSG_SENSITIVE_COMMUNITY_DELETE_SUCCESS:
    'Sensitive Community {0} has been deleted successfully.',
  MSG_CONFIG_DELETE_SUCCESS: 'Key "{0}" has been deleted successfully.',
  MSG_CONFIG_UPDATE_SUCCESS:
    'Changes to key "{0}" have been saved successfully.',
  MSG_CONFIRM_PILOT_DELETE:
    'Are you sure you want to delete pilot "{0}"? This pilot has no associations with Operators.',
  MSG_CONFIRM_PILOT_OPERATOR_DELETE:
    'Are you sure you want to delete pilot "{0}"? Associations it has with Operators will also be deleted.',
  MSG_CONFIRM_TAIL_DELETE:
    'Are you sure you want to delete tail number "{0}"? This tail number has no associations with Operators.',
  MSG_CONFIRM_TAIL_OPERATOR_DELETE:
    'Are you sure you want to delete tail number "{0}"? Associations it has with Operators will also be deleted.',
  MSG_CONFIRM_OPERATOR_DELETE:
    'Are you sure you want to delete flight operator "{0}"? This operator is not related to any pilots or tail numbers.',
  MSG_CONFIRM_DEPARTMENT_DELETE:
    'Are you sure you want to delete department "{0}"?',
  MSG_CONFIRM_OPERATOR_PILOT_TAIL_DELETE:
    'Are you sure you want to delete flight operator "{0}"? Any existing relationships with Pilots and Tail Numbers will also be deleted.',
  MSG_ROPE_ADD_SUCCESS:
    'New rope/conductor size "{0}" has been added successfully.',
  MSG_ROPE_DELETE_SUCCESS:
    'Rope/conductor size {0} has been deleted successfully.',
  MSG_ROPE_EDIT_SUCCESS:
    'Changes to rope/conductor size "{0}" have been saved.',
  MSG_FLIGHT_TYPE_ADD_SUCCESS: 'Flight Type "{0}" has been added successfully.',
  MSG_SENSITIVE_CITY_ADD_SUCCESS: 'Sensitive City "{0}" has been added successfully.',
  MSG_SENSITIVE_CITY_EDIT_SUCCESS: 'Changes to sensitive city "{0}" have been saved.',
  MSG_FLIGHT_TYPE_EDIT_SUCCESS: 'Changes to flight type "{0}" have been saved.',
  MSG_FLIGHT_TYPE_DELETE_SUCCESS:
    'Flight Type {0} has been deleted successfully.',
  MSG_SENSITIVE_CITY_DELETE_SUCCESS:
    'Sensitive City {0} has been deleted successfully.',
  MSG_POLYGON_ADD_SUCCESS: 'Polygon "{0}" has been added successfully.',
  MSG_POLYGON_EDIT_SUCCESS: 'Changes to polygon "{0}" have been saved.',
  MSG_POLYGON_DELETE_SUCCESS: 'Polygon "{0}" has been deleted successfully.',
  MSG_TAIL_ADD_SUCCESS: 'New tail number "{0}" has been added successfully.',
  MSG_TAIL_EDIT_SUCCESS: 'Changes to tail number "{0}" have been saved.',
  MSG_TAIL_DELETE_SUCCESS: 'Tail Number {0} has been deleted successfully.',

  MSG_DEPARTMENT_ADD_SUCCESS:
    'New department "{0}" has been added successfully.',
  MSG_DEPARTMENT_EDIT_SUCCESS: 'Changes to department "{0}" have been saved.',
  MSG_DEPARTMENT_DELETE_SUCCESS:
    'Department "{0}" has been deleted successfully.',

  MSG_PILOT_ADD_SUCCESS: 'Pilot "{0}" has been added successfully.',
  MSG_PILOT_EDIT_SUCCESS: 'Changes to pilot "{0}" have been saved.',
  MSG_PILOT_DELETE_SUCCESS: 'Pilot {0} has been deleted successfully.',

  MSG_FIRE_AGENCY_ADD_SUCCESS:
    'New fire agency "{0}" has been added successfully.',
  MSG_FIRE_AGENCY_EDIT_SUCCESS: 'Changes to fire agency "{0}" have been saved.',
  MSG_FIRE_AGENCY_DELETE_SUCCESS:
    'Fire agency {0} has been deleted successfully.',
  MSG_FIRE_AGENCY_RATE_ERROR: 'Rate should not be less than 0 USD.',
  MSG_FIRE_AGENCY_RATE_BLANK: 'The value entered must be a number',

  MSG_FLIGHT_OPERATOR_ADD_SUCCESS:
    'New flight operator "{0}" has been added successfully.',
  MSG_FLIGHT_OPERATOR_EDIT_SUCCESS:
    'Changes to flight operator "{0}" have been saved.',
  MSG_FLIGHT_OPERATOR_DELETE_SUCCESS:
    'Flight Operator {0} has been deleted successfully.',
  MSG_FLIGHT_OPERATOR_EMAIL_ERROR: 'Invalid email address!',

  MSG_OPERATOR_PILOT_ADD_SUCCESS:
    'New operator and pilot relationship has been added successfully.',
  MSG_OPERATOR_PILOT_EDIT_SUCCESS:
    'Changes to operator and pilot relationship have been saved.',
  MSG_OPERATOR_PILOT_DELETE_SUCCESS:
    'Operator and pilot relationship has been deleted successfully.',
  MSG_OPERATOR_PILOT_CONFIRM_DELETE:
    'Are you sure you want to delete this relationship?',

  MSG_DISTRICT_ADD_SUCCESS:
    'New district/project and company relationship, "{0}", has been added successfully.',
  MSG_DISTRICT_EDIT_SUCCESS:
    'Changes to district/project and company relationship, "{0}", have been saved.',
  MSG_DISTRICT_DELETE_SUCCESS:
    'District/Project and company relationship has been deleted successfully.',
  MSG_DISTRICT_CONFIRM_DELETE:
    'Are you sure you want to delete this relationship?',
  MSG_OPERATOR_TAIL_NUMBER_ADD_SUCCESS:
    'New operator and tail number relationship has been added successfully.',
  MSG_OPERATOR_TAIL_NUMBER_EDIT_SUCCESS:
    'Changes to operator and tail number relationship have been saved.',
  MSG_OPERATOR_TAIL_NUMBER_DELETE_SUCCESS:
    'Operator and tail number relationship has been deleted successfully.',
  MSG_OPERATOR_TAIL_NUMBER_CONFIRM_DELETE:
    'Are you sure you want to delete this relationship?',

  MSG_REQUEST_CANCELLED: 'Request has been cancelled.',
  MSS_REQUEST_PENDING: 'Request has been submitted for approval.',
  MSG_PHONE_NUMBER_ERROR: 'Invalid phone number',
  MSG_DATE_ERROR: 'Please select a valid date',
  MSG_TIME_ERROR: 'Please select a valid time',
  MSG_MILITARY_TIME_ERROR: 'Please enter a valid military time',
  MSG_TIME_START_ELAPSE_ERROR:
    'Please choose a time that has not already elapsed',
  MSG_TIME_DURATION_ERROR: 'Please choose an estimated flight time',
  MSG_TIME_ESTIMATE_ERROR:
    'Please give estimated time of release for jobs with standby time',

  MSG_TIME_ARRIVAL_ERROR: 'Arrival time must be greater than Departure Time',

  MSG_PASSENGER_CONFIRM_DELETE: 'Are you sure you want to delete {0}?',
  MSG_PASSENGER_DELETE_SUCCESS: 'Passenger {0} was removed.',
  MSG_EQUIPMENT_DELETE_SUCCESS: 'Equipment {0} was removed.',

  MSG_MULTIFLIGHT_DETAIL_CONFIRM_DELETE:
    'Are you sure you want to delete additional Flight Detail {0}?',
    MSG_MULTIFLIGHT_DELETE_SUCCESS: 'The selected Additional flight detail was removed.',

  MSG_CONFIRM_DELETE_FILES:
    'Do you want to delete files associated with a {0}?',

  MSG_FILE_CONFIRM_DELETE: 'Are you sure you want to delete this file?',
  MSG_FILE_DELETE_SUCCESS: 'File {0} was removed.',

  MSG_REQUEST_CREATE_SUCCESS: 'Flight request was successfully created.',
  MSG_REQUEST_UPDATE_SUCCESS: 'Flight request was successfully updated.',

  MSG_FIRE_DISPATCH_CREATE_SUCCESS: 'Fire dispatch was successfully created.',
  MSG_FIRE_DISPATCH_UPDATE_SUCCESS: 'Fire dispatch was successfully updated.',

  MSG_FIRE_DISPATCH_FLIGHT_NUMBER:
    'Flight number will be generated once the dispatch has been created.',
  MSG_FIRE_DISPATCH_MILITARY_TIME: 'Must be 4 digits',

  MSG_BRIEF_DESCRIPTION:
    'Please provide type of data collection (photo, LiDAR, IR, etc…), Drone make/model and upload a kmz, pdf, jpg, etc… file depicting the flight area.',
  MSG_CIRCUIT: '(Ex. Tielines, circuits, subs, address or structures)',
  MSG_PUBLIC_SAFETY: '(ex. flight near roads or airports)',
  MSG_EMPLOYEE_NUMBER_ERROR_DUPLICATE:
    'There should be no duplicate employee number for passengers',

  MSG_UPLOAD_CANCEL_SUCCESS: 'Upload was cancelled by the user',

  MSG_ADD_RISK_ASSESSMENT_SUCCESS:
    'New Risk Assesment for flight has been added successfully.',
  MSG_UPDATE_RISK_ASSESSMENT_SUCCESS:
    'Risk Assessment for flight has been updated successfully.',
  MSG_ERROR_PURPOSE_REQUIRED: 'Flight purpose is required.',
  MSG_ERROR_PURPOSE_MAX_LIMIT: 'Purpose should be max 200 characters.',
  MSG_ERROR_MAKE_SELECTION: 'Make a selection',
  MSG_ERROR_COST_CENTER_DIGIT: 'Must be digits only.',
  MSG_ERROR_COST_CENTER_NOT_VALID: 'Cost Center Number is Invalid.',
  MSG_ERROR_CND_WORK_ORDER_EMPTY: 'Work Order Number is required.',
  MSG_ERROR_WORK_ORDER_NOT_VALID:
    'Invalid Work Order number. W/O numbers must be up to 12 characters.',
  MSG_ERROR_IO_NUMBER_NOT_VALID:
    'Invalid IO number. IO Numbers must be 12 characters. Include preceding zeros if necessary.',
  MSG_ERROR_WORK_ORDER_DUPLICATE: 'This Work Order Number is already entered.',
  MSG_ERROR_IO_NUMBER_REQUIRED: 'IO Number is required',
  MSG_FILE_UPLOAD_SUCESS: 'File has been added successfully',
  MSG_FILE_DELETE_SUCESS: 'File has been deleted successfully',
  MSG_RECORDS_COUNT: 'Showing {0} records',
  MSG_NO_RECORDS_COUNT: 'No Records',
  MSG_EMAIL_SENT: 'Your email has been sent.',
  MSG_EMAIL_NOT_SENT: 'We encountered an error while sending your email.',
  MSG_DISPATCH_EMAIL_NOTIFICATION_TITLE: 'Email Notification',
  MSG_DISPATCH_EMAIL_NOTIFICATION:
    'Are you sure you want to send an email notification to the dispatch distribution?',
  MSG_DISPATCH_EMAIL_CANCELLED:
    'The firefighting flight for aircraft {0} at {1} has been cancelled .',
  MSG_DISPATCH_EMAIL_COMPLETED:
    '{0} stats for {1}<br/>Number of dips: {2}<br/>Number of drops: {3}<br/>Total Gallons dropped: {4}<br/>Total Flight time in hour(s): {5}',
  MSG_DISPATCH_EMAIL_DISPATCHED:
    'Aircraft {0} has been dispatched for the fire at {1}.',
  MSG_DISPATCH_EMAIL_DISPATCHED_COORDINATES:
    'Aircraft {0} has been dispatched for the fire at {1}, {2}.',
  MSG_DISPATCH_EMAIL_INFLIGHT:
    'Aircraft {0} is in-flight and responding to the fire at {1}.',
  MSG_DISPATCH_EMAIL_INFLIGHT_COORDINATES:
    'Aircraft {0} is in-flight and responding to the fire at {1}, {2}.',
  MSG_DISPATCH_EMAIL_LANDED:
    'Aircraft {0} has been released from the fire at {1}, and has landed at Gillespie Airport.',

  MSG_CONFIRM_DUPLICATE_REQUEST:
    'Are you sure you want to duplicate this flight request?',

  MSG_CONFIRM_DELETE_ACCOUNTING_INFO:
    'Are you sure you want to delete this accounting information?',

  MSG_SOMETHING_WENT_WRONG: 'Something went wrong. please try again later.',
  MSG_NO_RECORDS: 'There are currently no requests to display',
  MSG_REASON_COMMENT: 'Please describe the reason for cancellation:',

  MSG_VERIFY_FLIGHT_DATE:
    'A past date was selected for Flight Date. If you intended to select a date in the past; then no further action is required. If you did not intend to select a date in the past, please update accordingly.',

  MSG_REQUEST_UPDATE_COST_SUCCESS:
    'Flight cost updated and status set to Completed.',
  MSG_REQUEST_UPDATE_COST_FAILED: 'Flight cost failed to update.',
  MSG_STATUS_CHANGE_FAILED:
    'Status Change to "Complete" failed. Please go to Edit Request to continue status change.',
  MSG_RFC_TO_COMPLETE_REASON:
    'Cost provided ({0}) to set status of this flight to "Complete".',
  MSG_DRONE_AREAS_ADD_SUCCESS: 'Drone Areas "{0}" has been added successfully.',
  MSG_DRONE_AREAS_EDIT_SUCCESS: 'Changes to drone Areas "{0}" have been saved.',
  MSG_DRONE_AREAS_DELETE_SUCCESS:
    'Drone Areas "{0}" has been deleted successfully.',
};
